// The subject of a step of a history, as the user reads it: « Vous avez … »
// for their own steps, « William a … » for a colleague's, `fallback` (« Quelqu’un »,
// « Google Agenda ») when the api names nobody.
const activitySentence = (actor, meId, phrase, fallback = 'Quelqu’un') => {
  if (actor && meId && actor.id === meId) return `Vous avez ${phrase}`;
  const name = actor?.firstname || [actor?.firstname, actor?.lastname].filter(Boolean).join(' ') || fallback;
  return `${name} a ${phrase}`;
};

export default activitySentence;
